import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { version } from '../../../../package.json';
import auth from '../../../utils/auth';
import NormalButton from '../../components/buttons/normalButton';
import NormalInput from '../../components/inputs/normalInput';
import { getForm, getSchema, handleLogin } from './helper';
import { loginComplete } from '../../../redux/actions/login';
import { isValidEmail } from '../../../utils/index';
import './style.scss';

const Login = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const login = useSelector(state => state.login);
  const [isLoading, setLoading] = useState(false);

  const schema = getSchema();
  const form = getForm(schema);

  const onSubmit = async (e) => {
    e.preventDefault();
    form.clearErrors();
    if (!isValidEmail(form?.getValues('email'))) {
      form.setError('email', { message: 'Email format is incorrect.' }, { shouldFocus: true });
      return;
    }

    setLoading(true);
    const { email, password } = form.getValues();
    const {
      accessToken, me, error,
    } = await handleLogin(email.trim(), password.trim());
    if (_.isEmpty(me)) {
      form.setError('password', { message: 'Email or password is incorrect.' });
      setLoading(false);
      return;
    }
    if (!_.isEmpty(me)) {
      dispatch(loginComplete({
        isSuccess: true,
        login: me,
        accessToken,
      }));
    }
    setLoading(false);
  };

  useEffect(() => {
    if (login?.isSuccess || auth.isSuccess()) {
      history.replace('/reassign-eid');
    }
  }, [login]);

  return (
    <div className="login">
      <div className="login-form">
        <div className="login-form-header">
          Sign in
        </div>
        <div className="login-form-body">
          <form onSubmit={onSubmit}>
            <NormalInput
              name="email"
              title="Email"
              placeholder="Email"
              isUseForm
              control={form?.control}
              errMsg={form?.formState?.errors?.email?.message}
            />
            <NormalInput
              className="mt-24"
              name="password"
              title="Password"
              placeholder="Password"
              type="password"
              isUseForm
              control={form?.control}
              errMsg={form?.formState?.errors?.password?.message}
            />
            <NormalButton
              className="login-button mt-48"
              type="primary"
              text="sign in"
              disabled={!form?.formState?.isValid}
              onClick={onSubmit}
              loading={isLoading}
            />
          </form>
        </div>
        <div className="login-form-footer mt-8">
          <em>
            {`v${version}`}
          </em>
        </div>
      </div>
    </div>
  );
};

Login.defaultProps = {

};

Login.propTypes = {

};

export default Login;
